import { getProductEnv } from "utils";

const OTPLESS_LINK_DOMAIN = {
  STAGE: "io",
  PROD: "in",
  QA: "qa",
  DEV: "dev",
};

const GLOBAL_CONSTANT: any = {
  PRODUCT: "OTPLess",
  PSP_MODAL_STATUS: {
    NO_PSP_INSTALLED: "NO_PSP_INSTALLED",
    INVALID_PARAMS: "INVALID_PARAMS",
    USER_CLOSED: "USER_CLOSED",
  },
  API_STATUS: {
    SUCCESS: 1,
    LOADING: 0,
    FAIL: -1,
  },
  STATUS_REFRESH_API_TIMEOUT: 10000,
  STATUS_REFRESH_API_MAX_COUNT: 60,
  STATUS_CONSTANT: {
    SUCCESS: "Successful",
    FAILED: "Failed",
    FAILURE: "Failed",
    PENDING: "Pending",
    CANCELLED: "Cancelled",
    PARKED: "Successful",
  },
  OTPLESS_MAIL_ID: "helo@otpless.com",
  WROUTE: {
    TNC: "tnc",
    DIGIO: "digio",
    ADD_MONEY: "addMoneyTransactionInit",
  },
  URL_PARAMETER: {
    DOMAIN: "domain",
    WROUTE: "wroute",
    ORDER_ID: "OrderId",
    TXN_ID: "txnId",
    APP_VERSION: "appversion",
    CID: "cid",
    CONSUMER_ID: "consumerId",
    DEVICE_ID: "deviceId",
    INSTALL_ID: "installId",
    IS_VIRTUAL: "is_virtual",
    LATITUDE: "latitude",
    LONGITUDE: "longitude",
    MANUFACTURER: "manufacturer",
    MODEL: "model",
    PLATFORM: "platform",
    ROUTING_KEY: "routing_key",
    SERIAL: "serial",
    SIM_ID: "simId",
    TOKEN: "token",
    SESSION_TOKEN: "sessionToken",
    VERSION: "version",
    VISA: "visa",
  },
  loaderDetails: {
    first_message: "Loading",
    start_index: 0,
    range: 7,
    second_message: "Please Wait",
  },
};
export default GLOBAL_CONSTANT;
